var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440.603,
    height: 340.45,
    viewBox: "0 0 440.603 340.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "benefitslogo_SVG",
    "data-name": "benefitslogo SVG",
    transform: "translate(-77.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17960",
    "data-name": "Path 17960",
    d: "M126.7,36h-.142L77.62,121.439l48.937,85.439h97.9l48.937-85.439H175.637Z",
    transform: "translate(0 49.439)",
    fill: "#0487fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17961",
    "data-name": "Path 17961",
    d: "M98.3,36l48.937,85.439h97.756L196.056,36Z",
    transform: "translate(28.4 49.439)",
    fill: "#4ea6b2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    transform: "translate(274.201 170.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17962",
    "data-name": "Path 17962",
    d: "M160.252,121.439h.095L209.19,36h-.142L160.11,121.439h.142Z",
    transform: "translate(113.284 49.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17963",
    "data-name": "Path 17963",
    d: "M237.439,157.035,286.376,72h-97.97l-.024.261v-.024L139.54,156.276,188.5,240.5h97.875l-48.843-83.066Z",
    transform: "translate(85.035 98.878)",
    fill: "#1761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17964",
    "data-name": "Path 17964",
    d: "M299.285,72.027h-.214l.095-.047-48.843,84.466.024-.332L201.41,240.532h97.875l48.937-84.252Z",
    transform: "translate(170.001 98.85)",
    fill: "#7ebba9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17965",
    "data-name": "Path 17965",
    d: "M355.651,121.439,306.785,36H209.052L160.21,121.439h97.78L306.9,205.952l48.843-84.466Z",
    transform: "translate(113.421 49.439)",
    fill: "#219b74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17966",
    "data-name": "Path 17966",
    d: "M278.617,156.842l.047-.071-.024-.024L229.727,72.02,180.79,156.771l.095.641,48.843,84.133,48.581-84.133h.214Z",
    transform: "translate(141.683 98.905)",
    fill: "#198891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17967",
    "data-name": "Path 17967",
    d: "M188.427,121.439,237.507,36H139.49Z",
    transform: "translate(84.966 49.439)",
    fill: "#4bab30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17968",
    "data-name": "Path 17968",
    d: "M245.136,0h-97.9L98.3,85.439H294.074Z",
    transform: "translate(28.4)",
    fill: "#93ce7a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitslogo);
export default __webpack_public_path__ + "static/media/benefitslogo.d6cd0d491bc57b460df12e2dc2a2d109.svg";
export { ForwardRef as ReactComponent };